import { Flex } from '@chakra-ui/react';
import { OutlineCard, TextArea } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FormFieldNoveltyStatement } from '@publishing-engine/domain/types/article';
import { get } from 'lodash';
import { getValidationTypedMessage } from '../../../../../../components/FormField/common/errorMessages';

const NoveltyStatement = ({
  config
}: {
  config: FormFieldNoveltyStatement;
}) => {
  const {
    formState: { errors },
    register,
    watch
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const error = get(errors, field);
  const noveltyStatement = watch(field);

  return (
    <Flex flexDirection="column" gap={8}>
      <OutlineCard padding={8} borderless>
        <Flex flexDirection="column" gap={4}>
          <FieldLabel
            isRequired={validations.required}
            label={labels.section.title}
            subText={labels.section.explanation}
          />
          <TextArea
            placeholder=""
            value={noveltyStatement || ''}
            isInvalid={Boolean(error)}
            errorMessage={
              error &&
              getValidationTypedMessage(
                labels.main,
                validations.kind,
                validations,
                error
              )
            }
            characterLimit={validations.maxLength}
            {...register(field)}
          />
        </Flex>
      </OutlineCard>
    </Flex>
  );
};

export default NoveltyStatement;
